import React from 'react'

export const Divider = ({dividerColor='', dividerCurveColor=''}) => {

  const dividerClass = dividerColor ? `c-divider c-divider--${dividerColor}` : 'c-divider__curve'
  const dividerCurveClass = dividerCurveColor ? `c-divider__curve c-divider__curve--${dividerCurveColor}` : 'c-divider__curve'

  return (
    <div className={dividerClass}>
      <div className={dividerCurveClass}>
        <svg viewBox='0 0 1440 133' fill='none' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'>
          <path d='M721 -0.000917349C329 -0.000951619 0 68.9999 0 68.9999L720 68.9999L1440 69C1440 69 1113 -0.000883079 721 -0.000917349Z' fill='#F5F2F0'/>
          <rect y='69' width='1440' height='64' fill='#F5F2F0'/>
        </svg>
      </div>
    </div>
  )
}

